import { MapElementMixin, gmapApi } from "vue2-google-maps";
import { VBtn, VIcon } from "vuetify/lib";

export default {
	name: "KTrucksMapFollowButton",

	inject: [ "storeModuleName" ],

	mixins: [ MapElementMixin ],

	computed: {
		google: gmapApi,

		hasActiveMarker() {
			return this.$store.getters[`${this.storeModuleName}/hasActiveMarker`];
		},

		autoFollow: {
			get() {
				return this.$store.state[this.storeModuleName].autoFollow;
			},
			set( follow ) {
				this.$store.dispatch( `${this.storeModuleName}/setAutoFollow`, follow );
			}
		},

		followable() {
			return this.$store.state[this.storeModuleName].followable;
		},

		showButton() {
			return this.hasActiveMarker && this.followable && !this.autoFollow;
		}
	},

	created() {
		this.$mapPromise.then( () => {
			this.$map.controls[this.google.maps.ControlPosition.LEFT_BOTTOM].push( this.$el );
		} );
	},

	render() {
		return <div vShow={this.showButton}>
			<VBtn class="ma-2" onClick={() => this.autoFollow = true}>
				<VIcon>place</VIcon> Re-center
			</VBtn>
		</div>;
	}
};
